'use client';

import Box from '@/components/ui/Box';
import Flex from '@/components/ui/Flex';
import { vars } from '@/theme/vars.css';
import { UseCategoriesOptions, useCategoryChoice } from '@liquorice/next-search';
import { Checkbox } from '@mui/material';

export interface CheckboxesProps extends UseCategoriesOptions {
  label: string;
}

const Checkboxes = ({ label, ...config }: CheckboxesProps) => {
  const { options, name, isSelected, toggleValue } = useCategoryChoice({
    multiple: true,
    ...config,
  });

  return (
    <Flex spacing="5xs" cx={{ pX: '3xs' }}>
      {options?.map((option) => (
        <Box as="label" key={option.value}>
          <Checkbox
            sx={{
              '&.MuiCheckbox-root': {
                color: vars.palette.colors.black,
              },
              '&.Mui-checked': {
                color: vars.palette.colors.black,
              },
            }}
            name={name}
            value={option.value}
            checked={isSelected(option.value)}
            onChange={() => toggleValue(option.value)}
          />
          {option.label}
        </Box>
      ))}
    </Flex>
  );
};

export default Checkboxes;
